import { createBrowserHistory } from 'history';
import React from 'react';
import { Switch } from 'react-router';
import { Route, Router } from 'react-router-dom';
import './App.css';
import AppAdmin from './AppAdmin';
import AppGame from './AppGame';
import AppLogin from './AppLogin';
import { Amplify } from 'aws-amplify';
const history = createBrowserHistory({
  basename: window._env_.BASEPATH
})

Amplify.configure({
  API: {
    Events: {
      endpoint: `https://${window._env_.RTC_ENDPOINT}/event`,
      region: window._env_.RTC_REGION,
      defaultAuthMode: 'lambda',
    },
  }
})

declare global {
  interface Window { _env_: {
    API_ENDPOINT: string;
    BASEPATH: string;
    PUBLIC_URL: string;
    RTC_ENDPOINT: string;
    RTC_TOKEN: string;
    RTC_REGION: string;
  } }
}

const App: React.FC = () => {

  return (
    <div className="App">
      <Router history={history}>
        <Switch>
          <Route path="/participant">
            {() => (
              <AppGame mountPath="/participant" />
            )}
          </Route>
          <Route path="/admin">
            {() => (
              <AppAdmin mountPath="/admin" />
            )}
          </Route>
          <Route path='/' component={AppLogin} />
        </Switch>
      </Router>
    </div>
  );
};
export default App;
